<template>
  <MainLayout>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <template v-for="tab in tabs">
        <v-tab :key="tab.name" :to="{ name: tab.name }" ripple>{{ $t(tab.label) }}</v-tab>
      </template>
    </v-tabs>
    <router-view></router-view>
  </MainLayout>
</template>

<script>
export default {
  data() {
    return {
      currentView: 'ticket3-ticket-list',
      tabs: [
        {
          name: 'ticket3-ticket-list',
          label: 'ticket_list'
        },
        // {
        //   name: 'ticket3-agent-view',
        //   label: 'agent'
        // },
        {
          name: 'ticket3-funnel-view',
          label: 'funnel'
        },
        {
          name: 'ticket3-wrapup',
          label: 'Wrap Up'
        },
        {
          name: 'ticket3-setting',
          label: 'setting'
        }
      ],
      loading: true
    }
  },
  async mounted() {
    this.loading = true
    const allPromise = [
      this.$store.dispatch('loadAgentGroups'),
      this.$store.dispatch('loadAgentSubGroups'),
      this.$store.dispatch('loadAgents')
    ]
    await allPromise
    this.loading = false
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/LayoutTicketManagement.vue